import Image from 'next/image';
import { useState } from 'react';

function CampgroundImage({ campground }) {
  const [imgError, setImgError] = useState(false);
  const placeholderImage = '/placeholder/placeholder.png';
  const imageUrl = campground?.images?.[0]?.url;
  const image = imgError || !imageUrl ? placeholderImage : imageUrl;

  return (
    <Image
      src={image}
      width="500"
      height="500"
      alt={campground?.images?.[0]?.altText || campground.name}
      className={`rounded-t object-cover aspect-[4/3] h-full w-full`}
      onError={() => setImgError(true)}
      unoptimized={image.startsWith('https://')}
    />
  );
}

export default function Campgrounds({ campgrounds, parkName }) {
  return (
    <>
      <ul
        role="list"
        className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3"
      >
        {campgrounds.map((campground) => (
          <li
            key={campground.id}
            className="col-span-1 divide-y divide-beige-100/60 rounded bg-beige-30"
          >
            <div className="w-full relative">
              <span className="absolute top-2 left-2 flex-shrink-0 rounded-full bg-green-100 text-white px-3 py-1 text-xs font-black">
                {campground.campsites.totalSites} sites
              </span>

              {campground.images[0] ? (
                <div className={``}>
                  <CampgroundImage campground={campground} />
                </div>
              ) : null}

              <div className="flex-1 p-5">
                <h3 className="text-xl">{campground.name}</h3>
                {campground.addresses[0] ? (
                  <p className="mt-1 truncate text-sm text-gray-500">
                    {campground.addresses[0].city},{' '}
                    {campground.addresses[0].stateCode}
                  </p>
                ) : null}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </>
  );
}
